/* global $:true */
import debug from "debug";
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[ga-tracking-event]';
const PLUGIN_NAME = 'GaTrackingEvent';

$(() => {
	$(ELEMENT_SELECTOR).each(function(event) {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--ga-tracking-event" */ './ga-tracking-event'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/ga-tracking-event/index.js